import React from 'react';

import Default from './base/default';
import BrandHeader from '../components/organism/brandHeader';
import MainTitle from '../components/atoms/text/mainTitle';
import TextPassage from '../components/atoms/text/textpassage';

const Blank = ({pageContext: { page }}) => {
    return (
        <Default className="l-blank">
            <BrandHeader searchbar={false}></BrandHeader>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <MainTitle children={page.title.rendered}></MainTitle>
                        <TextPassage children={page.content.rendered}></TextPassage>
                    </div>
                </div>
            </div>
        </Default>  

     );
}
 
export default Blank;
